import React, { Component } from 'react';
import Alert from 'react-s-alert';

import {INDICADOR_TIPOSIMULADO, INDICADOR_SERIE/*, INDICADOR_ESCOLA*/, STATUS_SIMULADO} from '../../../const';

import * as IndicadorRequest from '../../../requests/indicador.request';

class Acompanhamento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingTipoSimulado: true,
            loadingSerie: true,
            loadingEscola: true,
            tiposimulado: {},
            serie: {},
            totalSerie: [],
            escola: {}
        }
    }

    getStatusColor(status) {
        if (status === STATUS_SIMULADO.CANCELADO) { return " adap-red "; }
        if (status === STATUS_SIMULADO.AGENDADO) { return " adap-light-gray "; }
        if (status === STATUS_SIMULADO.EM_REALIZACAO) { return " adap-light-yellow "; }
        if (status === STATUS_SIMULADO.REALIZADO) { return " adap-light-green "; }
        if (status === STATUS_SIMULADO.CORRIGIDO) { return " adap-blue "; }
        if (status === STATUS_SIMULADO.ANULADO) { return " adap-gray "; }
    }

    getScheduleColor(schedule) {
        if (schedule === "A realizar") { return " edb-yellow "; }
        if (schedule === "Em realização") { return " edb-green "; }
        if (schedule === "Prazo finalizado") { return " edb-red "; }
    }

    groupSituacao(obj) {
        console.log(obj)
        let response = obj.reduce((result, item) => {
            const practicetest = result.findIndex((res) => res.nuSchoolPeriod === item.nuSchoolPeriod && res.idPracticeTestType === item.idPracticeTestType);
            if(practicetest<0) {
                result.push({nuSchoolPeriod: item.nuSchoolPeriod, idPracticeTestType: item.idPracticeTestType, txPracticeTestType: item.txPracticeTestType, per: [{txYearSchedule: item.txYearSchedule, txMonthSchedule: item.txMonthSchedule, es: [{txStatusPracticeTest: item.txStatusPracticeTest, nuCount: item.nuCount}] } ]});
            }
            else {
                const period = result[practicetest].per.findIndex((res) => res.txYearSchedule === item.txYearSchedule && res.txMonthSchedule === item.txMonthSchedule);
                if(period<0) {
                    result[practicetest].per.push({txYearSchedule: item.txYearSchedule, txMonthSchedule: item.txMonthSchedule, es: [{txStatusPracticeTest: item.txStatusPracticeTest, nuCount: item.nuCount}] });
                }
                else {
                    result[practicetest].per[period].es.push({txStatusPracticeTest: item.txStatusPracticeTest, nuCount: item.nuCount});
                }
            }
            return result;
        }, []);

        // response.map((item, index) => {
        //     return
        // })

        return response;
    }

    getTipoSimulado(indicador) {
        if(Object.keys(this.state.tiposimulado).length===0) {
            return [];
        }
        return this.state.tiposimulado[indicador] || [];
    }

    getSerie(indicador) {
        if(Object.keys(this.state.serie).length===0) {
            return [];
        }
        return this.state.serie[indicador] || [];
    }

    async componentDidMount() {
        try {
            //Exibindo o loading
            this.setState({ loadingTipoSimulado: true, loadingSerie: true, loadingEscola: true });

            // Obtendo os indicadores
            var indicador_tiposimulado = {};
            var indicador_serie = {};

            indicador_tiposimulado[INDICADOR_TIPOSIMULADO.REALIZACOES] = await IndicadorRequest.getIndicadorTipoSimulado(INDICADOR_TIPOSIMULADO.REALIZACOES);

            // totaliza
            indicador_tiposimulado[INDICADOR_TIPOSIMULADO.REALIZACOES] = indicador_tiposimulado[INDICADOR_TIPOSIMULADO.REALIZACOES].map(item => {
                return {
                    ...item,
                    total: item.ets.reduce((partial_sum, a) => (partial_sum + a.nuCount),0)
                  };
            });

            indicador_tiposimulado[INDICADOR_TIPOSIMULADO.AGENDAMENTOS] = this.groupSituacao(await IndicadorRequest.getIndicadorTipoSimulado(INDICADOR_TIPOSIMULADO.AGENDAMENTOS));

            this.setState({
                tiposimulado: indicador_tiposimulado,
                loadingTipoSimulado: false
            });


            indicador_serie[INDICADOR_SERIE.REALIZACOES] = await IndicadorRequest.getIndicadorSerie(INDICADOR_SERIE.REALIZACOES);
            console.log(indicador_serie[INDICADOR_SERIE.REALIZACOES]);

            var total_serie = {};
            // totaliza indicador de série
            indicador_serie[INDICADOR_SERIE.REALIZACOES] = indicador_serie[INDICADOR_SERIE.REALIZACOES].map(grade => {
                return {
                    ...grade,
                    psg: grade.psg.map(item => {
                        return {
                            ...item,
                            total: item.ets.reduce((partial_sum, a) => {
                                if(!total_serie[a.idExamTakenStatus]) total_serie[a.idExamTakenStatus] = {idExamTakenStatus: a.idExamTakenStatus, nuCount:0, txExamTakenStatus: a.txExamTakenStatus};
                                total_serie[a.idExamTakenStatus].nuCount = total_serie[a.idExamTakenStatus].nuCount + a.nuCount;
                                return partial_sum + a.nuCount
                            },0)
                        };
                    })
                }
            });

            var totalSerie = [];
            var sumSerie = 0;
            Object.keys(total_serie).map( (serie) => {
                sumSerie = sumSerie + total_serie[serie].nuCount;
                totalSerie.push(total_serie[serie])
                return 0;
            });
            this.setState({
                serie: indicador_serie,
                totalSerie: totalSerie,
                sumSerie: sumSerie,
                loadingSerie: false
            });
        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possivel carregar os indicadores. Tente novamente mais tarde.", { position: 'bottom-right' });
            // window.location.hash = "#/";
        }
    }

    render() {
        return (
            <div className="edb-padding-top">

                <div className="edb-row">
                    <h3 className="edb-text-bolder edb-margin-top">Realizações por tipo de simulado</h3>
                    <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                        <thead className="edb-hide-small">
                            <tr>
                                <th className="edb-quarter">Período</th>
                                <th className="edb-quarter">Tipo de simulado</th>
                                <th className="edb-half">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.getTipoSimulado(INDICADOR_TIPOSIMULADO.REALIZACOES).map( (item, index) => (<tr key={'realizacoes_'+index}>
                                    <td className="edb-quarter">{item.nuSchoolPeriod}</td>
                                    <td className="edb-quarter">{item.txPracticeTestType}</td>
                                    <td className="edb-half">
                                        <div className="edb-responsive">
                                        <div className="edb-cell-row edb-flex edb-light-grey">
                                            {item.ets.map( (ets, ets_index) => (<div key={'realizacoes_status_'+index+'_'+ets_index} title={ets.nuCount+" simulados em situação '"+ets.txExamTakenStatus.toLowerCase()+"'"} className={"edb-container edb-padding-none edb-center edb-cell"+this.getStatusColor(ets.idExamTakenStatus)} style={{width:(ets.nuCount*100/item.total)+'%'}}>{ets.nuCount}</div>))}
                                        </div>
                                        </div>
                                    </td>
                                </tr>)
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="edb-row">
                    <h3 className="edb-text-bolder edb-margin-top">Agendamentos por tipo de simulado</h3>
                    <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                        <thead className="edb-hide-small">
                            <tr>
                                <th className="edb-quarter">Período</th>
                                <th className="edb-quarter">Tipo de simulado</th>
                                <th className="edb-half">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.getTipoSimulado(INDICADOR_TIPOSIMULADO.AGENDAMENTOS).map( (item, index) => (<tr key={'realizacoes_'+index}>
                                    <td className="edb-quarter">{item.nuSchoolPeriod}</td>
                                    <td className="edb-quarter">{item.txPracticeTestType}</td>
                                    <td className="edb-half">
                                        {item.per.map( (per, per_index) => (<div key={'agendamentos_status_'+index+'_'+per_index} title="Agendamentos simulado" className="edb-padding-small edb-center edb-cell-row edb-flex">{per.txMonthSchedule+"/"+per.txYearSchedule}: {per.es.map((es,es_index) => (<span key={'agendamentos_periodos_status_'+index+'_'+per_index+'_'+es_index} className="edb-margin-left">{es.txStatusPracticeTest} <span className={"edb-badge"+this.getScheduleColor(es.txStatusPracticeTest)}>{es.nuCount}</span></span>))} </div>))}
                                    </td>
                                </tr>)
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="edb-row">
                    <h3 className="edb-text-bolder edb-margin-top">Realizações por série</h3>{this.getSerie(INDICADOR_SERIE.REALIZACOES).map( (grade, index) => (<span key={"grade_"+index}>
                    <h5 className="edb-text-bolder edb-margin-top">- {grade.txGradeName}</h5>
                    <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                        <thead className="edb-hide-small">
                            <tr>
                                <th className="edb-quarter">Período</th>
                                <th className="edb-quarter">Tipo de simulado</th>
                                <th className="edb-half">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                        {grade.psg.map( (item, index) => (<tr key={'realizacoes_serie_'+index}>
                                    <td className="edb-quarter">{item.nuSchoolPeriod}</td>
                                    <td className="edb-quarter">{item.txPracticeTestType}</td>
                                    <td className="edb-half">
                                        <div className="edb-responsive">
                                        <div className="edb-cell-row edb-flex edb-light-grey">
                                            {item.ets.map( (ets, ets_index) => (<div key={'realizacoes_serie_status_'+index+'_'+ets_index} title={ets.nuCount+" simulados em situação '"+ets.txExamTakenStatus.toLowerCase()+"'"} className={"edb-container edb-padding-none edb-center edb-cell"+this.getStatusColor(ets.idExamTakenStatus)} style={{width:(ets.nuCount*100/item.total)+'%'}}>{ets.nuCount}</div>))}
                                        </div>
                                        </div>
                                    </td>
                                </tr>)
                        )}
                        </tbody>
                    </table>
                    </span>))}
                    <h5 className="edb-text-bolder edb-margin-top">- Total</h5>
                    <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                        <thead className="edb-hide-small">
                            <tr>
                                <th>Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="edb-responsive">
                                    <div className="edb-cell-row edb-flex edb-light-grey">
                                        {this.state.totalSerie.map( (serie, index) => (<div key={'realizacoes_serie_total_'+index} title={serie.nuCount+" simulados em situação '"+serie.txExamTakenStatus.toLowerCase()+"'"} className={"edb-container edb-padding-none edb-center edb-cell"+this.getStatusColor(serie.idExamTakenStatus)} style={{width:(serie.nuCount*100/this.state.sumSerie)+'%'}}>{serie.nuCount}</div>))}
                                    </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        );
    }
}

export default Acompanhamento;